import {
    Box,
    Typography,
    Grid,
    Card
} from '@mui/material'
import { VideoListUrl } from '../../../common/url'
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { ScreenWidthPort } from '../../../ScreenWidthContext'

export const SMAppPLInstructionVideo: React.FC = () => {
    const { screenWidth } = ScreenWidthPort()

    const { t } = useTranslation()

    const [data, setData] = useState(null)

    const fetchList = async () => {
        try {
            var url = VideoListUrl + '?sort=sequence:ASC&filters[type][$eq]=Personal Loan'
            const response = await axios.get(url)
            if (response.status === 200) {
                setData(response.data['data'])
            }
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        ; (async () => {
            await fetchList()
        })()
    }, [])

    const videoItem = (index: number) => {
        return (
            <Grid item key={index} xs={12}>
                <Box sx={{
                    width: '100%',
                    height: '100%',
                }}>
                    <Card style={{
                        width: '100%',
                        borderRadius: '10px',
                        outline: 'none', 
                        border: 'none',
                        boxShadow: '0px 10px 10px 1px rgba(76, 78, 100, 0.1)',
                    }}>
                        <iframe 
                        width='100%' 
                        height={screenWidth * 195 / 351}
                        src={data[index]['attributes']['link'] + '&rel=0'}
                        title='YouTube video player' 
                        frameBorder='0'
                        allow='accelerometer autoplay clipboard-write encrypted-media gyroscope picture-in-picture web-share' 
                        referrerPolicy='strict-origin-when-cross-origin' allowFullScreen>
                        </iframe>                    
                    </Card>
                    <Typography style={{ screenWidth: '100%', whiteSpace: 'break-spaces', paddingTop: '8px'}} fontSize={20} fontWeight={600} color={'#141F39'} >
                        {data[index]['attributes']['title']}
                    </Typography>
                </Box>
            </Grid>
        )
    }

    // ======================= VIEWS
    return (
        data !== null ? <Box
            sx={{
                width: '100%',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingTop: '60px',
            }}
        >
            <Typography fontSize={24} fontWeight={700} color={'#141F39'} textAlign={'center'}>
                {t('t447')}
            </Typography>

            <Box sx={{
                paddingTop: '40px',
            }}>
                <Grid container rowSpacing={3}>
                    {data.map((item, index) => (
                        videoItem(index)
                    ))}
                </Grid>
            </Box>
        </Box> : <Box></Box>
    )
}

// ======================= EXPORT
export default SMAppPLInstructionVideo
